import styled from '@app/styled';
import { color, typography } from '@app/theme';

export const Example = styled.p`
    color: ${color('text.light.default')};
    ${typography('custom.caption2')};
`;

export const Warning = styled.p`
    color: ${color('custom.yellow.500')};
    ${typography('custom.caption2')};
`;
